<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="mb-8">
            <label for="switch-asistencia-ia-activo" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('aiassist.activo')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-asistencia-ia-activo"
              :aria-label="$t('aiassist.activo')"
              class="switch-text break-normal both-switch " 
              v-model="form.Activo" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-4">
            <label for="switch-asistencia-ia-extraer-resumen" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('aiassist.extraer_resumen')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-asistencia-ia-extraer-resumen"
              :aria-label="$t('aiassist.extraer_resumen')"
              class="switch-text break-normal both-switch " 
              v-model="form.ExtraerResumen" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-4">
            <label for="switch-asistencia-ia-extraer-fechafintramite" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('aiassist.extraer_fechafintramite')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-asistencia-ia-extraer-fechafintramite"
              :aria-label="$t('aiassist.extraer_fechafintramite')"
              class="switch-text break-normal both-switch " 
              v-model="form.ExtraerFechaFinTramite" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-8">
            <label for="switch-asistencia-ia-extraer-grupo" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('aiassist.extraer_grupo')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-asistencia-ia-extraer-grupo"
              :aria-label="$t('aiassist.extraer_grupo')"
              class="switch-text break-normal both-switch " 
              v-model="form.ExtraerGrupo" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-4">
            <label for="switch-asistencia-ia-asignar-fechafintramite" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('aiassist.asignar_fechafintramite')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-asistencia-ia-asignar-fechafintramite"
              :aria-label="$t('aiassist.asignar_fechafintramite')"
              class="switch-text break-normal both-switch " 
              v-model="form.AsignarDirectamenteFechaFinTramite" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-6">
            <label for="switch-asistencia-ia-asignar-grupo" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('aiassist.asignar_grupo')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-asistencia-ia-asignar-grupo"
              :aria-label="$t('aiassist.asignar_grupo')"
              class="switch-text break-normal both-switch " 
              v-model="form.AsignarDirectamenteGrupo" 
              :active-text="$t('companies.active')"/>
          </div>

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import { getconfigia } from '@/services/clients/getconfigia'
import { updateconfigia } from '@/services/clients/updateconfigia'
import { i18n } from '@/i18n'

import { getClient } from '@/services/clients/getClient'

export default {
  /* eslint-disable camelcase */
  name: 'config-ia-assist',
  components: {
    DetailLayoutFullWidth,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('clients.ai_assist_header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations',
      },
      form: {
        Activo: false,
        ExtraerResumen: false,
        ExtraerFechaFinTramite: false,
        ExtraerGrupo: false,
        AsignarDirectamenteFechaFinTramite: false,
        AsignarDirectamenteGrupo: false,
      },
      rules: {
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
    isFromClient () {
      return this.id !== -1
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
  },
  created: async function () {
    const breadcrumbs = []

    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: this.$i18n.t('app.clients')
      })
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
      }
    }

    this.header.breadcrumb = breadcrumbs

    const data = await this.downloadData(this.id)
    this.setData(data)
  },
  mounted () {
    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations'
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
 
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idCliente: this.id,
            Activo: this.form.Activo,
            ExtraerResumen: this.form.ExtraerResumen,
            ExtraerFechaFinTramite: this.form.ExtraerFechaFinTramite,
            ExtraerGrupo: this.form.ExtraerGrupo,
            AsignarDirectamenteFechaFinTramite: this.form.AsignarDirectamenteFechaFinTramite,
            AsignarDirectamenteGrupo: this.form.AsignarDirectamenteGrupo,
          }
          const response = await updateconfigia(null, payload)
          if (response.blnError) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos actualizados correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
      else this.$router.push({ name: 'configurations/general' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getconfigia({ idCliente: this.id })
        if (template.blnError) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setData: function (data) {
      if (data) {
        this.form.Activo = data.Activo
        this.form.ExtraerResumen = data.ExtraerResumen
        this.form.ExtraerFechaFinTramite = data.ExtraerFechaFinTramite
        this.form.ExtraerGrupo = data.ExtraerGrupo
        this.form.AsignarDirectamenteFechaFinTramite = data.AsignarDirectamenteFechaFinTramite
        this.form.AsignarDirectamenteGrupo = data.AsignarDirectamenteGrupo
      }
      this.resetControlFormChanges()
    },
  }

}
</script>
